// // KnowledgeInitiative.jsx

// import React from "react";
// import KnowledgeCenter from "./KnowledgeCenter";
// import Initiative from "./Initiative";

// const KnowledgeInitiative = () => {
//   return (
//     <section className="w-full py-2 px-4">
//        <div className="section-title">
//             Knowledge Center &amp; Initiative
//           </div>
//       <div className="grid grid-cols-1 lg:grid-cols-[63%_35%] gap-6 items-center">
      
        
//         {/* Knowledge Center - 65% */}
//         <div className="w-full">
//           <KnowledgeCenter />
//         </div>

//         {/* Initiative - 35% */}
//         <div className="w-full">
//           <Initiative />
//         </div>

//       </div>
//     </section>
//   );
// };

// export default KnowledgeInitiative;




// new KnowledgeInitiative.jsx



import React from "react";
import KnowledgeCenter from "./KnowledgeCenter";
import Initiative from "./Initiative";

const KnowledgeInitiative = () => {
  return (
    <section className="w-full py-8 px-4 bg-white">
      <div className="section-title">
        Knowledge Center &amp; Initiative
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[63%_35%] gap-6 items-stretch">
        {/* Knowledge Center */}
        <div className="w-full h-full">
          <KnowledgeCenter />
        </div>

        {/* Initiative */}
        <div className="w-full h-full">
          <Initiative />
        </div>
      </div>
    </section>
  );
};

export default KnowledgeInitiative;